import "../models/slot.js";
import "./base.js";

// This will be used as a list of all the suggested slots that can appear. It will include the suggested slots for the
// currently selected date, across all the providers in the providers collection.

window.AppointmentBooking ??= {};
window.AppointmentBooking.SlotSuggester ??= {};
window.AppointmentBooking.SlotSuggester.Collections ??= {};

AppointmentBooking.SlotSuggester.Collections.Slots = class Slots extends (
  AppointmentBooking.SlotSuggester.Collections.Base
) {};
AppointmentBooking.SlotSuggester.Collections.Slots.prototype.model = AppointmentBooking.SlotSuggester.Models.Slot;
